// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.weight,\n.el-table th.weight {\n  width: 8em;\n}\n.el-table td.weight {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
